/**
 * Centralizes the env-configured Cognito group strings for each editorial
 * workflow role. The PURPOSE of each key is fixed in code; the group name
 * strings are environment-specific and may be obfuscated in customer deploys.
 *
 * `responseKey` is the field name on a user object (JWT profile or
 * /admin/clients-by-group response) that holds the group membership array.
 */
export const workflowGroups = Object.freeze({
  responseKey:      import.meta.env.VITE_GROUP_RESPONSE_KEY      as string,
  qualityControl:   import.meta.env.VITE_GROUP_QUALITY_CONTROL   as string,
  layoutAndDesign:  import.meta.env.VITE_GROUP_LAYOUT_AND_DESIGN as string,
  editorialManager: import.meta.env.VITE_GROUP_EDITORIAL_MANAGER as string,
  postProduction:   import.meta.env.VITE_GROUP_POST_PRODUCTION   as string,
})
